export default "__VITE_ASSET__LifvWEtl__"